import { imageType } from "api/interfaces/home/home.type";
import { ITable } from "api/interfaces/static-pages/competitor-pages.type";
import PAButton from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import ShippingPerks from "container/shipping-information/shipping-perks.component";
import PageContainer from "modules/components/PageContainer";
import Banner from "modules/static-pages/competitor-page/Banner";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import MetaHead from "modules/site-structure/common/MetaHead";
import { useRouter } from "next/router";
import Table from "../competitor-page/Table";
import styles from "./proudlyCanadianPage.module.scss";

interface IProps {
  staticData: {
    bannerImages: imageType[];
    shop_canada_button: {
      url: string;
      width: string;
      height: string;
    }[];
    users: {
      title: string;
      subTitle: string;
    };
    freeShippingCandianPage: {
      url: string;
      width: string;
      height: string;
    }
    gifShopCanadian: {
      url: string;
      width: string;
      height: string;
    }
    tables: ITable[];
    metaData: {
      metaKeywords: "",
      metaDescription: "",
      metaTitle: ""
    }
  }
}

function ProudlyCanadianPage(props: IProps) {
  const { staticData } = props;
  const { metaKeywords = "", metaDescription = "", metaTitle = "" } = staticData.metaData || {};
  const { t } = useTranslation("static-pages");

  const { query } = useRouter();
  const { pathname } = query;

  return (
    <PageContainer fullWidth className={styles.page_container}>
      <MetaHead {...{
        keywordsV2: metaKeywords, description: metaDescription, title: metaTitle, pathname,
      }}
      />

      <div className="d-flex flex-column align-items-center justify-content-center">
        <div className={`m-t-10 m-b-10 ${styles.banner_container}`}>
          <div>
            <Banner bannerImages={staticData.bannerImages} />
          </div>
        </div>
        <PAText component="h1" color="black" bold centerAlign>
          {t("For Canadians, By Canadians")}
        </PAText>
        <PAText className={styles.text_1} centerAlign>
          {t("proud_canadian_text_1")}
        </PAText>
        <Link href="/replacement-parts">
          <div className="m-t-20">
            <PAImage
              src={staticData.shop_canada_button[1].url}
              width={staticData.shop_canada_button[1].width}
              height={staticData.shop_canada_button[1].height}
            />

          </div>
        </Link>
        <div className={styles.user_info_container}>
          <ShippingPerks data={staticData.users} />
        </div>
        <div className={styles.free_shipping_section}>
          <div style={{ position: "relative", width: "100%", height: "calc(30 * var(--safari-root-font, 10px))" }}>
            <Image
              src={getRelativeImagePath(staticData.freeShippingCandianPage.url)}
              unoptimized
              alt="gif shop canadian"
              sizes="calc(30 * var(--safari-root-font, 10px))"
              fill
              style={{
                objectFit: "contain",
              }}
            />
          </div>
          <div className={styles.free_shipping_text}>
            <PAText bold>
              {t("Free shipping across Canada")}
            </PAText>
            <PAText fontSize={FONT_SIZE[5]} color="grey">
              {t("On orders over $99")}
            </PAText>
            <PAText color="grey" className="m-t-20">
              {t("proud_canadian_text_2")}
            </PAText>
            <PAText color="grey" className="m-t-20">
              {t("proud_canadian_text_3")}
              {" "}
            </PAText>
            <div className={styles.center_align_button}>
              <Link href="/replacement-parts">
                <PAButton className={styles.shopnow_button} widthAuto>
                  {t("SHOP NOW WITH FREE SHIPPING")}
                </PAButton>
              </Link>
            </div>
          </div>

        </div>
        <div className={`${styles.center_content_container}`}>
          <Table table={staticData.tables[0]} className={styles.table} rowBorder />
        </div>
        <div className={styles.para_2}>
          <div className={styles.gif_image} style={{ position: "relative", width: "100%", height: "calc(30 * var(--safari-root-font, 10px))" }}>
            <Image
              src={getRelativeImagePath(staticData.gifShopCanadian.url)}
              unoptimized
              alt="gif shop canadian"
              sizes="calc(30 * var(--safari-root-font, 10px))"
              fill
              style={{
                objectFit: "contain",
              }}
            />
          </div>
          <div>
            <PAText color="black">
              {t("Proud to be Canadian")}
            </PAText>
            <PAText color="grey">
              {t("proud_canadian_text_4")}
              <br />
              {" "}
              <br />
              {t("proud_canadian_text_5")}
            </PAText>
            <div className={`m-b-20 ${styles.center_align_button}`}>
              <Link href="/replacement-parts">
                <PAButton className={styles.shop_now_free_shipping_button} widthAuto>
                  {t("SHOP CANADIAN")}
                </PAButton>
              </Link>
            </div>
          </div>
        </div>
        <div>
          <PAText color="black" className={styles.footer_line} inlineBlock>
            {t("Join the 1,000,000+ Canadians who shop at Parts Avatar")}
          </PAText>
          <div className="d-flex align-items-center justify-content-center">
            <Link href="/replacement-parts">
              <PAButton className={styles.shopnow_button} widthAuto>
                {t("SHOP NOW WITH FREE SHIPPING")}
              </PAButton>
            </Link>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}

export default ProudlyCanadianPage;
